import React, { Component } from "react";
import "./education.css";
import { Link } from "react-router-dom";

class educationElement extends Component {

    render() {
        return (
            <React.Fragment key={this.props.Key}>
                <div className="education-item">
                    <Link to={`/educationdetail/${this.props.id}`}>
                        <img src={`${this.props.imageUrl}`} className="figure-img img-fluid " alt="..." />
                        <figure className="figure">
                            <figcaption className="figure-caption">
                                <h3 className="mb-3 link-caption">
                                    {this.props.title}
                                </h3>
                                <span className="edu-company">{this.props.location}</span>
                                <p className="lead">
                                    {this.props.description}
                                </p>
                            </figcaption>
                            <blockquote className="blockquote">
                                <p>هزینه دوره: {this.props.price}</p>
                            </blockquote>
                        </figure>
                    </Link>
                </div>
            </React.Fragment >
        );
    }
}

export default educationElement;